import React, { ReactNode, createContext, useContext } from "react";

import { User } from "../services/api/AuthUser";

type AuthContextType = {
  currentUser: User;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider");
  }

  return context;
};

export const AuthProvider: React.FC<{ currentUser: User; children: ReactNode }> = ({
  currentUser,
  children,
}) => {
  return <AuthContext.Provider value={{ currentUser }}>{children}</AuthContext.Provider>;
};
